import IProduct from "@/interfaces/product.interface";
import { ProductsMessages } from "@/messages/products/product.messages";
import { FilterAttributes, FilterType, FilterValue, IFilter } from "@/types/filter.types";
import { SelectData } from "@/types/form.types";

import { ProductFilterKey } from "./types";

export const PRODUCTS_TABLE_COLUMNS = (messages: ProductsMessages) => [
  messages.expandColumn,
  messages.codeColumn,
  messages.titleColumn,
  messages.brandColumn,
  messages.stockColumn,
  messages.typeColumn,
  messages.statusColumn,
  messages.optionsColumn,
];

export const FILTER_OPTIONS = (messages: ProductsMessages): SelectData<ProductFilterKey>[] => [
  { label: messages.allOption, value: "all" },
  { label: messages.codeOption, value: "code" },
  { label: messages.titleOption, value: "title" },
  { label: messages.brandOption, value: "brand" },
  { label: messages.statusOption, value: "active" },
  { label: messages.skuCodeOption, value: "SKU.Code" },
  { label: messages.skuEanOption, value: "SKU.Ean" },
];

export const STATUS_OPTIONS = (messages: ProductsMessages): SelectData<boolean>[] => [
  { label: messages.statusTrueOption, value: true },
  { label: messages.statusFalseOption, value: false },
];

export const KIT_OPTIONS = (messages: ProductsMessages): SelectData<boolean>[] => [
  { label: messages.kitTrueOption, value: true },
  { label: messages.kitFalseOption, value: false },
];

export const HAS_PHOTO_OPTIONS = (messages: ProductsMessages): SelectData<boolean>[] => [
  { label: messages.hasPhotoTrueOption, value: true },
  { label: messages.hasPhotoFalseOption, value: false },
];

export const FILTER_ATTRIBUTES: Partial<Record<ProductFilterKey, FilterAttributes>> = {
  all: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "disable",
  },
  active: {
    defaultValue: true,
    type: FilterType.Equals,
    valueType: "boolean",
  },
  code: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },

  title: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  shortDescription: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  description: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  brand: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  ncm: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  "SKU.Code": {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  "SKU.Ean": {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  "sku.code": {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  "sku.ean": {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  "SKU.Kit": {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "boolean",
  },
  "SKU.Active": {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "boolean",
  },
  "sku.kit": {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "boolean",
  },
  "sku.active": {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "boolean",
  },
  hasProductImages: {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "boolean",
  },
};

export const FILTER_OPTION_VALUES = (
  messages: ProductsMessages
): Partial<Record<ProductFilterKey, SelectData<FilterValue>[]>> => ({
  active: STATUS_OPTIONS(messages),
  code: [],
  title: [],
  shortDescription: [],
  description: [],
  brand: [],
  ncm: [],
  "SKU.Kit": KIT_OPTIONS(messages),
  "SKU.Active": STATUS_OPTIONS(messages),
  "sku.kit": KIT_OPTIONS(messages),
  "sku.active": STATUS_OPTIONS(messages),
  hasProductImages: HAS_PHOTO_OPTIONS(messages),
});

export const initialFilterValues: IFilter<IProduct>[] = [];
